import React, { useEffect, useState } from 'react';

interface SuccessMessageProps {
  message: string;
  duration?: number;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ 
  message, 
  duration = 3000 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setIsVisible(true);

      const timer = setTimeout(() => {
        setIsVisible(false);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [message, duration]);

  if (!message) return null;

  return (
    <div 
      style={{ 
        color: "green",
        opacity: isVisible ? 1 : 0,
        transition: "opacity 300ms ease-in-out",
        fontSize: "19px",
      }}
    >
      {message}
    </div>
  );
};

export default SuccessMessage;